import { dispatch, getState } from '../../..';
import PumpingStationMotorEfficiencyHelper, { IPumpingStationMotorEfficiency } from '../../../../@types/model/masterData/pumpingStation/motorEfficiency';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationMotorEfficiencyActions from './actions';

export default class MasterDataPumpingStationMotorEfficiencyFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationMotorEfficiencyFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationMotorEfficiencyActions.setLoading(true));
        dispatch(MasterDataPumpingStationMotorEfficiencyActions.set([]));

        try {
            MasterDataPumpingStationMotorEfficiencyFunctions.listener = PumpingStationMotorEfficiencyHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationMotorEfficiency>) => {
                    const state = getState().masterData.pumpingStation.motorEfficiency;

                    const list = state.motorEfficiencies.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationMotorEfficiencyActions.set(list));
                    dispatch(MasterDataPumpingStationMotorEfficiencyActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationMotorEfficiencyActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationMotorEfficiencyActions.setLoading(false));
                    MasterDataPumpingStationMotorEfficiencyFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationMotorEfficiencyActions.setLoading(false));
        }
    };
}